import { QueryClientProvider as Provider } from 'react-query'
import { queryClient } from '@/services/api'

/**
 * @param {object} props
 * @param {React.ReactNode} [props.children]
 */
export function QueryClientProvider({ children }) {
  return <Provider client={queryClient}>{children}</Provider>
}
